"use client";
import React, { ReactNode, useEffect, useState, useCallback } from "react";
import { useMediaQuery } from "@mui/material";
import { useSession } from "next-auth/react";
import { useCookies } from "react-cookie";

type AppUAContextValue = {
  sdkState: any | null;
};

export const AppUAContext = React.createContext<AppUAContextValue>({
  sdkState: null,
});
AppUAContext.displayName = "AppUAContext";

export const AppUAProvider = ({ children }: { children: ReactNode }) => {
  const [sdkState, setSdkState] = useState(null);
  const session = useSession();
  const isMobile = useMediaQuery("(max-width:700px)");
  const [cookies] = useCookies(["cookieConsent"]);

  const getUA = useCallback(async () => {
    if (cookies.cookieConsent) {
      if (typeof window !== "undefined" && !isMobile) {
        try {
          //@ts-ignore
          const sdk = await window.UA;
          const { channelId } = await sdk.create();
          console.log("registered channel with id:", channelId);
          setSdkState(sdk);
          sdk.setDataCollectionEnabled(true);
          //REMOVED NOTIFICATIONS POP UP
          // const pluginHtmlPrompt = await sdk.plugins.load(
          //   // globally unique plugin identifier; we always use `html-prompt`
          //   "html-prompt",
          //   // URL to the html-prompt script; this example is for the US data center
          //   "https://aswpsdkus.com/notify/v2/ua-html-prompt.min.js",
          //   // options passed to the plugin
          //   {
          //     type: "alert",
          //     i18n: {
          //       en: {
          //         title: "Recibe un 10% de descuento ",
          //         message:
          //           "Activa tus notificaciones y obtén un descuento al explorar nuestro catálogo o antes de finalizar tu compra",
          //         accept: "Aceptar",
          //         deny: "No, gracias",
          //       },
          //     },
          //   },
          // );
          // pluginHtmlPrompt.prompt();
          if (session.status === "authenticated") {
            // const namedUser = await sdk.channel._namedUser._getName();
            // const contChanges = await sdk.channel.namedUserChanges;
            // if (namedUser === null && contChanges <= 5) {
            // await sdk.channel._namedUser._setName(session.data?.user.email);
            // sdk.channel._named_user_id = session.data?.user.email;
            await sdk.contact.identify(session.data?.user.email);
            // const contact = await sdk.contact();
            // await contact.identify(session.data?.user.email); // associates this channel with a Named User
            // Remove the currently associated Named User
            //await sdk.contact.reset();
            // }
          }
        } catch (ex) {
          console.error(ex);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.data?.user.email, session.status, cookies]);
  useEffect(() => {
    getUA();
  }, [getUA, session.status]);

  return (
    <AppUAContext.Provider
      value={{
        sdkState: sdkState,
      }}
    >
      {children}
    </AppUAContext.Provider>
  );
};
